import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import TextField from '@mui/material/TextField'; 
const emails = ['username@gmail.com', 'user02@gmail.com'];

function SimpleDialog(props) {
  const { onClose,  open,processClaimedAmount,claimedAmountD } = props;
  const[formData, setFormData] = React.useState({});
  React.useEffect(() => {
    setFormData({claimed_amount: claimedAmountD});
    
  }, [claimedAmountD]);
  //setFormData({claimed_amount: claimedAmountD});
  const handleClose = () => {
    onClose();
  };

  const handleListItemClick = (value) => {
    onClose();
  };
  const onConfirmation = () => {
    processClaimedAmount(formData.claimed_amount);
    onClose(formData.claimed_amount);
  };
  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Confirm claimed amount</DialogTitle>
      <TextField className="textField" id="amount-claimed" label="Claimed amount" variant="outlined" onChange={(e) => setFormData({ ...formData, claimed_amount: e.target.value })} value={formData.claimed_amount}/>
      <Button className="buttonField" variant="contained" onClick={onConfirmation}>Confirm</Button>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function AmountConfirmationCard(props) {
    const { opend,claimedAmountD,processClaimedAmount } = props;
    
  const [open, setOpen] = React.useState(false);
  
  const [claimedAmount, setClaimedAmount] = React.useState(claimedAmountD);
  React.useEffect(() => {
    setOpen(opend);
    setClaimedAmount(claimedAmountD);
  }, [opend, claimedAmountD]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
   
  };

  return (
    <div>
     
      <SimpleDialog
        
        open={open}
        onClose={handleClose}
        claimedAmountD={claimedAmountD}
        processClaimedAmount={processClaimedAmount}
      />
    </div>
  );
}
